import moment from 'moment';

export const MONTHS_NAMES = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december'
];
export enum DAYS_NAMES {
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  saturday = 'saturday',
  sunday = 'sunday'
}

export const DAYS_PER_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export const startOf = (year: number) => new Date(year, 0, 1, 0, 0, 0);
export const endOf = (year: number) => new Date(year, 11, 31, 0, 0, 0);

function nullableDatesAreSameDay(date1?: Date | null, date2?: Date | null) {
  return date1 === date2 || (date1 instanceof Date && date2 instanceof Date && areSameDays(date1, date2));
}

function areSameDays(date1: Date, date2: Date) {
  if (date1.getDay() === date2.getDay() && Math.abs(date1.getTime() - date2.getTime()) < (24 * 3600 * 1000)) {
    return true;
  }
  return false;
}

export function addDays(date: any, daysNumber: number) {
  const d = new Date(date);
  d.setDate(d.getDate() + daysNumber);
  return d;
}

function getNow(): any {
  const today = new Date();
  return today;
}

function getDate(ts: any) {
  return ts === undefined ? new Date() : new Date(ts);
}

/* formate to YYYYMMDD_hhmm in english or DDMMYYYY_hhmm in fr */
function formatDateForName(date: Date, locale: string): string {
  const t = moment(date);
  if (locale === 'fr') {
    return t.format('DDMMYYYY_hhmm');
  }
  return t.format('YYYYMMDD_hhmm');
}

function formatDate(date: Date, format: string, locale?: any) {
  if (locale) {
    return moment(date).locale(locale).format(format);
  }
  return moment(date).format(format);
}

export function dateIsAfter(testedDate: any, referenceDate: any) {
  return (testedDate.getTime() - referenceDate.getTime()) > 0;
}

function getSeconds(date: any) {
  return moment(date).unix();
}

function getLandHHMMFormat(timeStamp: number, locale: string = 'en', utc?: boolean) {
  const unixDate = utc ? moment.utc(timeStamp) : moment(timeStamp);
  return `${unixDate.locale(locale).format('L').slice(0, 5)} ${unixDate.format('HH:mm')}`;
}

export function localeDateFromUTC(sourceDate: string | Date): Date {
  const localeDate = new Date(sourceDate);
  const year = localeDate.getUTCFullYear();
  const month = localeDate.getUTCMonth();
  const date = localeDate.getUTCDate();
  const hour = localeDate.getUTCHours();
  localeDate.setFullYear(year, month, date);
  localeDate.setHours(hour);
  localeDate.setMinutes(0);
  return localeDate;
}

export function localeDateToUTC(sourceDate: Date): Date {
  const utcDate = new Date(sourceDate);
  const year = utcDate.getFullYear();
  const month = utcDate.getMonth();
  const date = utcDate.getDate();
  const hour = utcDate.getHours();
  utcDate.setUTCFullYear(year, month, date);
  utcDate.setUTCHours(hour);
  utcDate.setUTCMinutes(0);
  return utcDate;
}

const timeHelper = {
  getNow,
  MONTHS_NAMES,
  addDays,
  getDate,
  formatDate,
  dateIsAfter,
  nullableDatesAreSameDay,
  getSeconds,
  getLandHHMMFormat,
  formatDateForName
};

export default timeHelper;
